export default __webpack_public_path__ + "static/media/rates.9fdfcb43.jpeg";